// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scrumboard-view {
    margin: 0 0.5rem;
}

/* Lewy panel - lista umów (scrollowana) */
.scrum-contracts-list {
    max-height: 70vh;
    overflow-y: auto;
}

.scrum-contract-item {
    padding: 0.5rem 0.6rem;
    margin-bottom: 0.25rem;
    border: 1px solid var(--bs-border-color, #dee2e6);
    border-left: 3px solid var(--section-border-our, #0d6efd);
    border-radius: 0.375rem;
    cursor: pointer;
    transition: background-color 0.15s ease, box-shadow 0.15s ease;
}

.scrum-contract-item:hover {
    background-color: var(--bs-light, #f8f9fa);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.scrum-contract-item.active {
    background-color: var(--bs-primary-bg-subtle, #cfe2ff);
    border-left-width: 5px;
}

.scrum-contract-item.discussed {
    opacity: 0.6;
}

.scrum-contract-label {
    cursor: pointer;
    min-width: 0;
}

.scrum-discussed-separator {
    border-top: 2px dashed var(--bs-secondary, #6c757d);
    margin: 0.5rem 0;
}

/* Akcje masowe na pasku kart (z prawej) */
.scrum-tabbar-wrap {
    position: relative;
}

.scrum-tab-actions {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
}

/* Na wąskich ekranach przyciski nad kartami, aby nie nachodziły na zakładki */
@media (max-width: 991px) {
    .scrum-tab-actions {
        position: static;
        margin-bottom: 0.5rem;
    }
}

/* Wiersz zadania i inline-edycja */
.scrum-task-row {
    padding: 0rem 0;
}

.scrum-task-name {
    min-width: 4rem;
}

/* Uwagi zadania — widoczne dopiero po zaznaczeniu wiersza.
   pre-wrap zachowuje łamanie linii wpisane w polu "Uwagi" (textarea). */
.scrum-task-description {
    white-space: pre-wrap;
    margin-top: 0.15rem;
}

.scrum-task-owner {
    max-width: 10rem;
}

.scrum-task-field {
    white-space: nowrap;
    flex-shrink: 0;
}

.scrum-inline-value {
    cursor: pointer;
    border-bottom: 1px dotted var(--bs-secondary, #6c757d);
}

.scrum-inline-value:hover {
    background-color: var(--bs-warning-bg-subtle, #fff3cd);
}

.scrum-inline-input {
    display: inline-block;
    width: 5rem;
}

/* Rozsuwanie pól godzin dziennych (animacja szerokości zamiast nagłego pojawienia) */
.scrum-week-hours {
    display: inline-flex;
    gap: 0.25rem;
    max-width: 0;
    overflow: hidden;
    transition: max-width 0.28s ease;
    vertical-align: middle;
}

.scrum-week-hours.open {
    max-width: 21rem;
}

.scrum-day-input {
    width: 3.6rem;
    text-align: center;
    padding: 0.15rem 0.2rem;
}

.scrum-status-toggle {
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/Scrumboard/Scrumboard.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA,0CAA0C;AAC1C;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,iDAAiD;IACjD,yDAAyD;IACzD,uBAAuB;IACvB,eAAe;IACf,8DAA8D;AAClE;;AAEA;IACI,0CAA0C;IAC1C,yCAAyC;AAC7C;;AAEA;IACI,sDAAsD;IACtD,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,mDAAmD;IACnD,gBAAgB;AACpB;;AAEA,0CAA0C;AAC1C;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,UAAU;AACd;;AAEA,8EAA8E;AAC9E;IACI;QACI,gBAAgB;QAChB,qBAAqB;IACzB;AACJ;;AAEA,mCAAmC;AACnC;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;wEACwE;AACxE;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,sDAAsD;AAC1D;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA,qFAAqF;AACrF;IACI,oBAAoB;IACpB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".scrumboard-view {\n    margin: 0 0.5rem;\n}\n\n/* Lewy panel - lista umów (scrollowana) */\n.scrum-contracts-list {\n    max-height: 70vh;\n    overflow-y: auto;\n}\n\n.scrum-contract-item {\n    padding: 0.5rem 0.6rem;\n    margin-bottom: 0.25rem;\n    border: 1px solid var(--bs-border-color, #dee2e6);\n    border-left: 3px solid var(--section-border-our, #0d6efd);\n    border-radius: 0.375rem;\n    cursor: pointer;\n    transition: background-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.scrum-contract-item:hover {\n    background-color: var(--bs-light, #f8f9fa);\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n.scrum-contract-item.active {\n    background-color: var(--bs-primary-bg-subtle, #cfe2ff);\n    border-left-width: 5px;\n}\n\n.scrum-contract-item.discussed {\n    opacity: 0.6;\n}\n\n.scrum-contract-label {\n    cursor: pointer;\n    min-width: 0;\n}\n\n.scrum-discussed-separator {\n    border-top: 2px dashed var(--bs-secondary, #6c757d);\n    margin: 0.5rem 0;\n}\n\n/* Akcje masowe na pasku kart (z prawej) */\n.scrum-tabbar-wrap {\n    position: relative;\n}\n\n.scrum-tab-actions {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 2;\n}\n\n/* Na wąskich ekranach przyciski nad kartami, aby nie nachodziły na zakładki */\n@media (max-width: 991px) {\n    .scrum-tab-actions {\n        position: static;\n        margin-bottom: 0.5rem;\n    }\n}\n\n/* Wiersz zadania i inline-edycja */\n.scrum-task-row {\n    padding: 0rem 0;\n}\n\n.scrum-task-name {\n    min-width: 4rem;\n}\n\n/* Uwagi zadania — widoczne dopiero po zaznaczeniu wiersza.\n   pre-wrap zachowuje łamanie linii wpisane w polu \"Uwagi\" (textarea). */\n.scrum-task-description {\n    white-space: pre-wrap;\n    margin-top: 0.15rem;\n}\n\n.scrum-task-owner {\n    max-width: 10rem;\n}\n\n.scrum-task-field {\n    white-space: nowrap;\n    flex-shrink: 0;\n}\n\n.scrum-inline-value {\n    cursor: pointer;\n    border-bottom: 1px dotted var(--bs-secondary, #6c757d);\n}\n\n.scrum-inline-value:hover {\n    background-color: var(--bs-warning-bg-subtle, #fff3cd);\n}\n\n.scrum-inline-input {\n    display: inline-block;\n    width: 5rem;\n}\n\n/* Rozsuwanie pól godzin dziennych (animacja szerokości zamiast nagłego pojawienia) */\n.scrum-week-hours {\n    display: inline-flex;\n    gap: 0.25rem;\n    max-width: 0;\n    overflow: hidden;\n    transition: max-width 0.28s ease;\n    vertical-align: middle;\n}\n\n.scrum-week-hours.open {\n    max-width: 21rem;\n}\n\n.scrum-day-input {\n    width: 3.6rem;\n    text-align: center;\n    padding: 0.15rem 0.2rem;\n}\n\n.scrum-status-toggle {\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
